import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { Location } from '@angular/common';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-add-holidays',
  templateUrl: './add-holidays.component.html',
  styleUrls: ['./add-holidays.component.scss'],
})
export class AddHolidaysComponent implements OnInit {
  holiday = { name: '', date: '' };
  id: any;
  constructor(
    private page: Location,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private route: Router,
    private service: ApiService,
    private router: ActivatedRoute,
    private datePipe: DatePipe
  ) {
    this.router.params.subscribe((route) => {
      this.id = route['id'];
    });
  }

  ngOnInit() {
    if (this.id) {
      this.getHolidatById();
    }
  }
  get buttonTitle() {
    return this.id ? 'Edit Holiday' : 'Add Holiday';
  }
  onSubmit() {
    if (this.id) {
      this.spinner.show();
      const requestData = {
        name: this.holiday.name,
        date: this.holiday.date,
      };
      this.service
        .putRequest(`${ApiUrl.updateHoliday}${this.id}`, requestData)
        .subscribe(
          (res: any) => {
            this.toastr.success(res.response.message);
            this.route.navigate(['/holidays']);
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
            this.toastr.error('An error occurred while update holiday');
          }
        );
    } else {
      this.spinner.show();
      const requestData = {
        name: this.holiday.name,
        date: this.holiday.date,
      };
      this.service.postRequest(ApiUrl.addHolidays, requestData).subscribe(
        (res: any) => {
          this.toastr.success(res.response.message);
          this.route.navigate(['/holidays']);
          this.spinner.hide();
        },
        (err) => {
          this.spinner.hide();
          this.toastr.error('An error occurred while saving holiday');
        }
      );
    }
  }

  getHolidatById() {
    this.spinner.show();
    this.service
      .getRequest(`${ApiUrl.getHolidayById}${this.id}`)
      .subscribe((res: any) => {
        this.spinner.hide();
        if (res.response.success == true) {
          this.holiday = res.response.data;

          const holidayDate = new Date(this.holiday.date);
          this.holiday.date = this.datePipe.transform(
            holidayDate,
            'yyyy-MM-dd'
          )!;
          // console.log(this.storeForm, "getstore")
        }
      });
  }

  onBack() {
    this.page.back();
  }
}
